'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const components_marketing_CTA_constants = require('./constants.cjs.js');

const getBgColor = (backgroundColor) => {
  return components_marketing_CTA_constants.BgColorMap[backgroundColor] || backgroundColor;
};
const getCtaBtnColor = (bgColor, ctaBtnColor) => {
  const background = getBgColor(bgColor);
  const allowedButtonTypes = {
    // Note: Value present at 0th Index is considered as the default color value
    neutral100: ["primary", "primary-alt", "brand"],
    zapier: ["primary-dark"],
    night: ["primary-dark", "brand"],
    moss: ["primary-dark", "brand"],
    neutral800: ["primary-dark", "brand"],
    earth: ["primary-dark", "brand"]
  };
  if (ctaBtnColor && allowedButtonTypes[background].includes(ctaBtnColor)) {
    return ctaBtnColor;
  }
  return allowedButtonTypes[background][0];
};

exports.getBgColor = getBgColor;
exports.getCtaBtnColor = getCtaBtnColor;
//# sourceMappingURL=utils.cjs.js.map
